import React from 'react';
import { twMerge } from 'tailwind-merge';
import { InputSwitch } from 'primereact/inputswitch';

const SharedModelListItem = ({ text, index, isMarked, errors, className, onChangeSwitch, disabled, readOnly }) => {
    const handleOnChange = (e) => {
        onChangeSwitch(index, e.value);
    };

    return (
        <div>
            <div className={twMerge('flex justify-between items-center pb-2 w-full space-x-4', className)}>
                <span className={`text-theme1-title2 ${isMarked ? 'font-bold' : 'font-semibold'}`}>{text}</span>
                {!readOnly && (
                    <div className='flex space-x-4 items-start'>
                        <div className='flex items-center space-x-2'>
                            <div className='flex items-center space-x-2'>
                                <InputSwitch
                                    inputId={text}
                                    name={text}
                                    checked={isMarked}
                                    onChange={handleOnChange}
                                    disabled={disabled}
                                />
                                {errors &&
                                    errors.map((error) => {
                                        return (
                                            <div key={error} className='mt-2.5 text-theme1-error'>
                                                {error}
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SharedModelListItem;
